/*
 *
 * PciResponsabilityModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-202
*/

import { connect } from 'react-redux'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'
import { doHideToast, doShowToast } from 'Store/actions/toast'
import PciResponsabilityModal from './PciResponsabilityModal'
import { doSendQuestionnaire, doAnswerQuestion, doGetCompanyData, doGetShops } from 'Route/Pci/modules/PciActions'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup()),
  doShowToast: (toastType, data) => dispatch(doShowToast(toastType, data)),
  doHideToast: () => dispatch(doHideToast()),
  doSendQuestionnaire: (payload) => dispatch(doSendQuestionnaire(payload)),
  doAnswerQuestion: (payload) => dispatch(doAnswerQuestion(payload)),
  doGetCompanyData: () => dispatch(doGetCompanyData()),
  doGetShops: () => dispatch(doGetShops())
})

const mapStateToProps = (state) => ({
  pciData: nullSafe(() => state.popup.popupInfo.pciData, {}),
  protectionLevel: nullSafe(() => state.popup.popupInfo.protectionLevel, null),
  userProfile: nullSafe(() => state.userProfiling.profiling, {}),
  companyData: nullSafe(() => state.Pci.companyData, {}),
  isCompanyDataLoading: nullSafe(() => state.loading.localLoading.get_company_data, false),
  shops: nullSafe(() => state.Pci.shops, []),
  isShopsLoading: nullSafe(() => state.loading.localLoading.get_shops, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PciResponsabilityModal)
